import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { ASSET_CLASS_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import AssetClassDialog from "./AssetClassDialog";
import Tooltip from "@mui/material/Tooltip"

function AssetClass() {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const [data, setData] = useState([]);

  useEffect(() => {
    getAssetClasses();
  }, []);

  const getAssetClasses = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(ASSET_CLASS_URL).then((response) =>
      setData(response.data.data)
    );
  };

  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <AssetClassDialog assetClassId={0}
          selectedClassName={""}
          callAssetClasses={getAssetClasses}
          actionType={"Add"}
          isEdit={false} />
      </Box>
      {/* Table View */}
      {/* <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Class Name</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((ac, index) => {
                  return (
                    <StyledTableRow>
                      <StyledTableCell>{ac.name}</StyledTableCell>
                      <StyledTableCell>
                        {ac.status ? "Acitve" : "In-Active"}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box> */}

      {/* App Table view */}
      <AppTableView
        rows={data}
        initialPageSize={15}
        cols={[
          {
            field: "name", headerName: "Class Name", flex: 1, renderCell: (params) => {
              return (
                <AssetClassDialog
                  assetClassId={params.row.id}
                  selectedClassName={params.value}
                  callAssetClasses={getAssetClasses}
                  actionType={"Edit"}
                  isEdit={true}
                />
              );
            },
          },
          {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => {
              return <Tooltip title={params.value}>{params.value}</Tooltip>
            },
          },
          {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => {
              const statusColors = {
                false: "error",
                true: "success",
              };
              return (
                <Chip
                  label={params.value ? "Active" : "Inactive"}
                  color={statusColors[params.value]}
                  size="small"
                />
              );
            },
          },
        ]}
      ></AppTableView>
    </Container>
  );
}

export default AssetClass;
